import {
  createRouteRef,
  createSubRouteRef,
} from '@backstage/frontend-plugin-api';

export const rootRouteRef = createRouteRef();

export const insightsRouteRef = createRouteRef();

export const integrationsRouteRef = createRouteRef();

export const integrationsDetailsSubRouteRef = createSubRouteRef({
  parent: integrationsRouteRef,
  path: '/:id',
});

export const checksRouteRef = createRouteRef();

export const checksNewSubRouteRef = createSubRouteRef({
  parent: checksRouteRef,
  path: '/create-new',
});

export const checksEditSubRouteRef = createSubRouteRef({
  parent: checksRouteRef,
  path: '/:id/edit',
});

export const checksDetailsSubRouteRef = createSubRouteRef({
  parent: checksRouteRef,
  path: '/:id',
});

export const tracksRouteRef = createRouteRef();

export const tracksNewSubRouteRef = createSubRouteRef({
  parent: tracksRouteRef,
  path: '/create-new',
});

export const tracksEditSubRouteRef = createSubRouteRef({
  parent: tracksRouteRef,
  path: '/:id/edit',
});

export const tracksDetailsSubRouteRef = createSubRouteRef({
  parent: tracksRouteRef,
  path: '/:id',
});
